import { render, staticRenderFns } from "./Commons.vue?vue&type=template&id=06c3c487&scoped=true"
import script from "./Commons.vue?vue&type=script&lang=js"
export * from "./Commons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c3c487",
  null
  
)

export default component.exports